export const ARGOS_CARD_PROVIDED = 'ArgosCard'
export const PAYPAL_PROVIDED = 'PayPalCredit'
export const KLARNA_PROVIDED = 'Klarna'
